module.exports = __webpack_public_path__ + "static/media/moon.c39d9ab6.png";